import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ALARM_NOTIFICATION_LIST_URL } from '../../connection.data';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BasicService } from '../../_base/services/basic.service';

@Injectable()
export class AlarmNotificationListService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_ALARM_NOTIFICATION_LIST_URL;
    }
}